import React, {useEffect} from "react";
import "./style.css";
import {Image} from "../../../../../components/Image";

export const PcUserScale = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
  useEffect(() => {
    if (clicked) {
      clickNext("")
    }
  }, [clicked]);
  return (
    <div className="user-scale-pc" data-model-id="16859:358">
      <div className="contents">

        <div className="container">
          <Image src="/static/image/questionnaire/fasting/user-scale/pc/image-container.png" alt="Image container" className="image-container" />

          <div className="text-container">
            <div className={'title'}>
              <span className="title-highlight">3 Million</span>
              <span>People</span>
            </div>

            <p className="subtitle">
              have achieved their weight goals by fasting with Calo
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
